const frequency = [
  {
    value: 'daily',
    text: 'Diário',
  },
  {
    value: 'weekly',
    text: 'Semanal',
  },
  {
    value: 'monthly',
    text: 'Mensal',
  },
  {
    value: 'bimonthly',
    text: 'Bimestral',
  },
  {
    value: 'quarterly',
    text: 'Trimestral',
  },
  {
    value: 'semiannual',
    text: 'Semestral',
  },
  {
    value: 'annual',
    text: 'Anual',
  },
]

export default frequency
